import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CalcShell from "../../components/CalcShell";
import CalcField from "../../components/CalcField";
import { formatINR } from "../../utils/format";

const meta = { slug: "emi", emoji: "🏠", title: "EMI Calculator", desc: "Find your monthly loan instalment instantly." };

function EMICalculator() {
  const [principal, setPrincipal] = useState(2500000);
  const [rate, setRate] = useState(8.5);
  const [years, setYears] = useState(20);

  const n = years * 12;
  const r = rate / 100 / 12;
  const emi = r > 0 ? (principal * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1) : principal / n;
  const total = emi * n;
  const interest = total - principal;

  return (
    <CalcShell
      meta={meta}
      note={
        <span>
          <strong>Tip:</strong> A shorter tenure raises your EMI but slashes total
          interest. Even small prepayments early in the loan save lakhs.
        </span>
      }
    >
      <Row>
        <Col md={6}>
          <CalcField label="Loan amount (₹)" value={principal} onChange={setPrincipal} min={50000} max={20000000} step={50000} prefix="₹" />
          <CalcField label="Interest rate (% p.a.)" value={rate} onChange={setRate} min={1} max={20} step={0.1} suffix="%" />
          <CalcField label="Loan tenure (years)" value={years} onChange={setYears} min={1} max={30} step={1} suffix="yr" />
        </Col>
        <Col md={6}>
          <div className="fi-calc-result mb-3">
            <div>Monthly EMI</div>
            <div className="big">{formatINR(emi)}</div>
          </div>
          <Row className="g-3">
            <Col xs={6}>
              <div className="fi-stat">
                <div className="num">{formatINR(interest)}</div>
                <small className="text-muted">Total interest</small>
              </div>
            </Col>
            <Col xs={6}>
              <div className="fi-stat">
                <div className="num">{formatINR(total)}</div>
                <small className="text-muted">Total payment</small>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </CalcShell>
  );
}

export default EMICalculator;
